import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, RotateCcw } from "lucide-react";
import { useAuthedApi, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export default function AdminPanel({ onChange }) {
  const api = useAuthedApi();
  const [demo, setDemo] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => { api("get", "/admin/demo-data").then(setDemo); };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const run = async (method, msg) => {
    setBusy(true);
    try { await api(method, "/admin/demo-data"); toast.success(msg); load(); onChange?.(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="lux-card p-6 sm:p-8 max-w-2xl space-y-6" data-testid="admin-panel">
      <div>
        <p className="eyebrow mb-2">Demo / sample data</p>
        <p className="text-sm text-gray-400">All sample cars and dealers are tagged "Demo". Remove them in one click when your real sellers are live. Real listings are never touched.</p>
      </div>
      {demo && (
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 rounded-2xl bg-black/40 border border-white/5"><p className="font-display text-4xl gold-text" data-testid="admin-demo-listings">{demo.listings}</p><p className="text-xs uppercase tracking-widest text-gray-500">Demo cars</p></div>
          <div className="p-4 rounded-2xl bg-black/40 border border-white/5"><p className="font-display text-4xl gold-text" data-testid="admin-demo-dealers">{demo.dealers}</p><p className="text-xs uppercase tracking-widest text-gray-500">Demo dealers</p></div>
        </div>
      )}
      <div className="flex flex-wrap gap-3">
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <button className="px-6 py-3 rounded-full bg-red-600 hover:bg-red-500 text-white font-semibold flex items-center gap-2 disabled:opacity-50" disabled={busy || !demo || (demo.listings + demo.dealers === 0)} data-testid="admin-delete-demo-button"><Trash2 className="w-4 h-4" />Delete all demo data</button>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-[#111319] border-[#D4AF37]/30 text-white">
            <AlertDialogHeader>
              <AlertDialogTitle>Delete all demo data?</AlertDialogTitle>
              <AlertDialogDescription className="text-gray-400">This removes every sample car and dealer store. Real user listings stay untouched.</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel className="bg-transparent border-white/20 text-white" data-testid="admin-delete-cancel">Cancel</AlertDialogCancel>
              <AlertDialogAction className="bg-red-600 hover:bg-red-500" onClick={() => run("delete", "All demo data deleted")} data-testid="admin-delete-confirm">Delete</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
        <button className="btn-outline" disabled={busy} onClick={() => run("post", "Demo data restored")} data-testid="admin-restore-demo-button"><RotateCcw className="w-4 h-4" />Restore demo data</button>
      </div>
    </div>
  );
}
